import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FTEDashboard } from '../interface/ftedashboard';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class FteDashboardService {

  
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private httpClient: HttpClient) { }

  getOLEAvgFTETrend(data: any): Observable<any[]>{
    // return this.httpClient.post<any[]>(this.baseUrl + 'getOLEAvgFTETrend', data);

    return this.httpClient.post<any[]>(this.O3CoreApiUrl + 'OperatorsSaturation/GetOLEAvgFTETrend', data);
  
  }
  getOLEAvgFTETrendRecourceWise(data: any): Observable<any[]>{
    // return this.httpClient.post<any[]>(this.baseUrl + 'getOLEAvgFTETrendRecourceWise', data);
    return this.httpClient.post<any[]>(this.O3CoreApiUrl + 'OperatorsSaturation/GetOLEAvgFTETrendRecourceWise', data);
    
  }
  getOleResourcesUtilizationByProject(data: any): Observable<any[]>{
    // return this.httpClient.post<any[]>(this.baseUrl + 'getOleResourcesUtilizationByProject', data);
    return this.httpClient.post<any[]>(this.O3CoreApiUrl + 'OperatorsSaturation/GetOleResourcesUtilizationByProject', data);
  }
}
